import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/img/logo-1.png";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 50) {
        setShowNavbar(true);
      } else if (window.scrollY > lastScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div className={`navbar${showNavbar ? "" : " navbar--hidden"}`}>
      <div className="nav-logo">
        <Link to="/">
          <img src={Logo} alt="logo LM Couleurs" />
        </Link>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </div>

      {/* Menu mobile */}
      {menuOpen ? (
        <div className="mobile-menu">
          <div className="nav-links open">
            <ul>
              <li>
                <Link to="/" onClick={toggleMenu}>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={toggleMenu}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/realisations" onClick={toggleMenu}>
                  Réalisations
                </Link>
              </li>
              <li>
                <Link to="/faq" onClick={toggleMenu}>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div className="nav-contact open">
            <Link to="/contact" onClick={toggleMenu}>
              <button className="btn-contact">Contact</button>
            </Link>
          </div>
        </div>
      ) : (
        <>
          <div className="desktop-menu">
            <div className="nav-links">
              <ul>
                <li>
                  <Link to="/">Accueil</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/realisations">Réalisations</Link>
                </li>
                <li>
                  <Link to={"/faq"}>FAQ</Link>
                </li>
              </ul>
            </div>
            <div className="nav-contact">
              <Link to="/contact">
                <button className="btn-contact">Contact</button>
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Navbar;
